import PropTypes from 'prop-types';
import { DangerousHtmlContent, NotificationPanel } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { price as priceUtils, constants } from '@eti/utils';
import { CLIMATE_COMPENSATION } from '../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const ClimateCompensationNotification = _ref => {
  let {
    priceRaw
  } = _ref;
  const {
    t
  } = useTranslation();
  const title = t('Product.ClimateCompensation.Notification.Title');
  const content = t('Product.ClimateCompensation.Notification.Content', priceUtils.formatPrice(priceRaw));
  return /*#__PURE__*/_jsx(NotificationPanel, {
    dataTestId: "climate-compensation-notification",
    icons: [{
      id: 'circle',
      color: '#18a638',
      size: '3rem'
    }, {
      id: 'climate-compensation',
      color: '#fff',
      size: '2rem'
    }],
    title: title,
    type: constants.notificationTypes.NOTIFICATION_CLIMATE_COMPENSATION,
    children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: content,
      "data-offer-rate": CLIMATE_COMPENSATION.id
    })
  });
};
ClimateCompensationNotification.propTypes = {
  priceRaw: PropTypes.number
};
export default ClimateCompensationNotification;
//# sourceMappingURL=ClimateCompensationNotification.js.map